<template>
  <v-card flat class="card-box dt-border pad-10">
    <v-container>
      <v-row>
        <v-col class="box-title" cols="12" md="8">
          <div>
            <h2 class="card-title">Wallet Balances</h2>
            <p>Please select a wallet to freeze or unfreeze</p>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div v-if="can('can_manage_users')" >
            <v-btn @click="unblockWallet()"  depressed v-if="details.nairawallet.status == 'disabled' " :loading = "unblockBtn" dark color="success" style="float: right;font-size:12px"> Unblock Wallet </v-btn>
            <v-btn @click="blockWallet()"  depressed v-if="details.nairawallet.status == 'active' " :loading="blockBtn" dark color="error" style="float: right;font-size:12px"> Block Wallet</v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="balance-card card py-4">
            <div class="balance d-flex flex-column justify-center">
              <div class="px-3 text-center">
                <div class="card-text pr-1 mb-3">Wallet Balance</div>
                <div class="amount">{{ formatMoney(details.nairawallet.availablebalance) }}</div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="info-card dt-border card py-4">
            <div class="info-details d-flex flex-column justify-center">
              <div class="px-3 ">
                <v-list justify="center" color="transparent " style="margin:auto;bac">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon v-if="details.hasAddedBankAccount" color="success">
                        mdi-checkbox-marked-circle
                      </v-icon>
                      <v-icon color="red" v-if="!details.hasAddedBankAccount">
                        mdi-close-circle
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="dt-orange__text">
                        <span>Bank Account(s)</span>
                        <span v-if="details.hasAddedBankAccount" @click="viewBanks" class="accent--text" style="float:right;cursor:pointer">view</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon v-if="details.hasTransactionPin" color="success">
                        mdi-checkbox-marked-circle
                      </v-icon>
                      <v-icon color="red" v-if="!details.hasTransactionPin">
                        mdi-close-circle
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="dt-orange__text"><span>Transaction Pin</span></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon v-if="details.hasValidatedBVN" color="success">
                        mdi-checkbox-marked-circle
                      </v-icon>
                      <v-icon color="red" v-if="!details.hasValidatedBVN">
                        mdi-close-circle
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="dt-orange__text"><span>BVN</span></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <!-- <div class="amount" v-else>&#8358;900.00</div> -->
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <account-modal @closeModal = "bankModal = false" :banks="details.banks" :dialog="bankModal"/>
  </v-card>
</template>

<script>
// ============ IMPORT COMPONENT ===========
import AccountModal from './account-modal.vue'

// ============ IMPORT SERVICES =========
import { UsersService } from '@/services';
import {formatMoney} from '@/utils/moneyFormatter';

export default {
  props:{
    details:{
      type: Object
    }
  },
  data:() =>({
    bankModal : false,
    blockBtn : false,
    unblockBtn : false,

  }),
  components:{
    AccountModal
  },
  methods:{
    formatMoney(amount){
      return formatMoney(amount)
    },
    async blockWallet(){
      try {
        this.blockBtn = true;
        const data = await UsersService.BlockWallet({
          id : this.details.nairawallet.id
        })
        this.blockBtn = false;
        this.$store.dispatch('toast', {
          message: data.message,
          variant: 'success'
        });
        this.details.nairawallet.status = data.wallet.status
      } catch (error) {
        this.blockBtn = false
      }
    },
    async unblockWallet(){
      try {
        this.unblockBtn = true;
        const data = await UsersService.UnblockWallet({
          id : this.details.nairawallet.id
        })
        this.unblockBtn = false;
        this.$store.dispatch('toast', {
          message: data.message,
          variant: 'success'
        });
        this.details.nairawallet.status = data.wallet.status
      } catch (error) {
        this.unblockBtn = false
      }
    },
    viewBanks(){
      this.bankModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.card-title {
  font-weight: 600 !important;
  font-size: 20px;
  // font-family: "Inter", sans-serif;
  letter-spacing: 1px;
}
.card-box {

  h2 {
    font-weight: 500;
  }
}
.box-title {
  p {
    font-size: 14px;
    color: #656565;
    letter-spacing: 0.5px;
  }
}
.card {
  display: flex;
  height: calc(100% - 57px);
  height: 170px;
  border-radius: 10px;
  box-shadow: 0px 8px 6px -4px rgba(0, 0, 0, 0.25) !important;

  .balance, .info-details {
    border-bottom-left-radius: inherit;
    border-top-left-radius: inherit;
    width: 100%;

    .card-text {
      font-size: 12px;
      // color: #fff;
      line-height: 12px;
    }

    .amount {
      font-size: 39px;
      font-family: BebasNeue, sans-serif;
      // color: #fff;
      line-height: 100%;
    }

    .naira-sign {
      color: rgba(255, 255, 255, 0.3);
    }
  }
}
.balance-card{
    background: rgb(232, 80, 40);
    background: linear-gradient(
    180deg,
    rgba(232, 80, 40, 1) 0%,
    rgb(240, 105, 38) 100%
  );
  color: #fff;
  }
.info-card{
  background: #f7f7f7;
  color: red;
}

</style>